export default $axios => ({
    getGalleryAllImages() {
        return $axios({
            method: 'GET',
            url: '/base/gallery/all_images'
        });
    },
    getGallery() {
        return $axios({
            method: 'GET',
            url: '/base/gallery'
        });
    },
    getGalleryItemsById(id) {
        return $axios({
            method: 'GET',
            url: `/base/gallery/${id}`,
            redirectOnError: true
        });
    }
});
